/**
 * Thin wrappers around localStorage / sessionStorage.
 * - All reads are wrapped in try/catch so private browsing / storage-full errors are silent.
 * - String values are returned as-is; valid JSON strings are automatically parsed.
 * - Objects/arrays/booleans/numbers are JSON-serialised on write.
 */

function _read(storage, key, fallback) {
  try {
    const raw = storage.getItem(key);
    if (raw === null) return fallback;
    try { return JSON.parse(raw); } catch { return raw; }
  } catch { return fallback; }
}

function _write(storage, key, value) {
  try {
    storage.setItem(key, typeof value === "string" ? value : JSON.stringify(value));
  } catch {}
}

export function getLocal(key, fallback = null)   { return _read(localStorage,  key, fallback); }
export function setLocal(key, value)             { _write(localStorage,  key, value); }

export function getSession(key, fallback = null) { return _read(sessionStorage, key, fallback); }
export function setSession(key, value)           { _write(sessionStorage, key, value); }
export function removeSession(key)               { try { sessionStorage.removeItem(key); } catch {} }
